export default __webpack_public_path__ + "static/media/FreightSmith_JACKALOPE_ICON.699a95c8.png";